import { SpecificationCollapseItem } from './components/SpecificationCollapse/types';

export interface DetailedCarFullSpecificationProps {
  array: DetailedCarFullSpecificationItem[];
}

export interface DetailedCarFullSpecificationItem {
  name: string;
  code: CodeItems;
  items: SpecificationCollapseItem[];
  isOpened?: boolean;
}

export enum CodeItems {
  ENGINE = 'engine',
  BODY = 'body',
  OPERATION_PARAMS = 'operation_params',
  BATTERY = 'battery',
  COMPLECTATION = 'complectation',
  LIKE = 'like',
}
